<template>
    <div>
      <div id="editor-3975">
        <textarea id="editor" ref="editor" v-model="editorContent"></textarea>
      </div>
    </div>
  </template>
  <script>
    import $ from "jquery";
    import '../assets/wysibb.css'
    export default {
      name: 'bbcode-editor',
      data() {
        return {
          none: false,
          wbbOpt: {
            lang: 'cn',
            buttons: "bold,italic,underline,link,|,removeformat",
          },
          action: this.$BaseURL + 'upload-img',
          editorContent: ''
        };
      },
      props: {
        content: String
      },
      mounted() {
        var that = this
        $(this.$refs.editor).wysibb(this.wbbOpt);
        if (this.content != "") {
          $(this.$refs.editor).htmlcode(this.content);
        }
  
        this.$nextTick(() => {
          // Firefox和Chrome早期版本中带有前缀
          const MutationObserver = window.MutationObserver|| window.WebKitMutationObserver || window.MozMutationObserver
          // 创建观察者对象
          const observer = new MutationObserver(mutations=>{
            mutations.forEach(function(mutation) {
              $('.wysibb-body img').each(function() {
              var src = $(this).attr('src')
              var _this = this
              if(src.indexOf('http') == -1) {
                $(_this).remove()
                that.$Message.error('图片不支持拖拽、粘贴')
              }
            })
          })   
        }) 
        // 配置观察选项:
        const config = { 
          attributes: true, 
          childList: true, 
          characterData: true 
        }
        // 选择目标节点
        const target = document.querySelector('.wysibb-body');
        // 传入目标节点和观察选项
        observer.observe(target, config);
        })
      },
      methods: {
        handleError() {
          this.$toast('上传图片失败')
        },
        handleSuccess(res, file) {
          if (file.response.status == 1) {
            $(this.$refs.editor).insertAtCursor(
              `<img src='${file.response.data.url}' style="max-width: 100%;display: block;margin:10px auto"/>`);
            this.$toast(file.response.msg)
          } else {
            this.$toast(file.response.msg)
          }
        },
        getcode() {
          //获取编辑器bbcode后的内容
          return $(this.$refs.editor).bbcode()
        },
        gethtml() {
          //获取编辑器原来的html内容
          return $(this.$refs.editor).htmlcode()
        },
      },
      watch: {
        editorContent: {
          immediate: true,
          handler(e) {
            
          }
        }
      }
    };
  </script>
  
  <style lang="less">
    #editor-3975 {
      height: 200px;
      position: relative;
      .wysibb {
        .wysibb-toolbar {
          height: 44.89px;
          .wysibb-toolbar-container {
            height: 100%;  
            display: inline-flex;
            justify-content: center;
            align-items: center;
            &.modeSwitch {
              display: none;
            }
          }
        }
      }
      // 表情
      .editor-emioj {
        width: 26px;
        position: absolute;
        left: 13px;
        top: 10px;
        height: 26px;
        z-index: 101;
        background: url("../assets/wysibb_icons.png");
        background-size: 50px;
        background-position-x: 0;
        cursor: pointer;
      }
  
      .ivu-upload.ivu-upload-select {
        width: 49px;
        height: 44.89px;
        position: absolute;
        left: 154px;
        z-index: 110;
  
        //上传图片
      }
  
      //上传视频
      .editor-video {
        width: 28px;
        position: absolute;
        left: 202px;
        top: 10px;
        height: 26px;
        z-index: 101;
        background-color: red;
        background: url("../assets/wysibb_icons.png");
        background-size: 50px;
        background-position-y: -208px !important;
        cursor: pointer;
      }
  
      .wysibb {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 100;
      }
  
      // //上传视频
      .wbb-video {
        .btn-inner {
          display: block;
          height: 26px;
          min-width: 26px;
          margin: 2px;
          text-indent: -9999px;
          background: url(/img/wysibb_icons.919f5f35.png) !important;
          background-size: 50px !important;
          background-position-x: 0px !important;
          background-position-y: -208px !important;
        }
      }
  
      // .wbb-removeformat {
      //   margin-left: 71px !important;
      // }
    }
  
    .wysibb-text-editor.wysibb-body {
      height: 142px !important;
      font-size: .7rem;
      img {
        max-width: 100%;
        margin: 0 auto;
        display: block;
      }
    }
  
    #wbbmodal {
      z-index: 10000;
  
      .modal-content {
        position: relative;
        border: none;
        border-radius: 0;
        overflow: hidden;
        box-shadow: none;
        background-color: #fff;
        background-clip: padding-box;
  
        .modal-header {
          color: #fff;
          background: #d9b581;
          padding: 15px;
          border-bottom: 1px solid #e5e5e5;
  
          .close {
            color: #fff;
            opacity: 1;
            font-weight: lighter;
            margin-top: -2px;
            -webkit-appearance: none;
            padding: 0;
            cursor: pointer;
            background: 0 0;
            border: 0;
            float: right;
            font-size: 21px;
            line-height: 1;
            text-shadow: 0 1px 0 #fff;
          }
          h4 {
            font-size: 18px;
            font-weight: normal;
          }
        }
        .modal-body {
          .wbbm-cont {
            padding: 20px;
            label {
              display: block;
              color: #666;
              font-size: 12px;
              margin-bottom: 8px;
            }
            .inp-text {
              padding: 0 15px;
              background: #f0f0f0;
              border: 1px solid #FAFAFA;
              border-radius: 3px;
              line-height: 40px;
              width: 100%;
              outline: 0
            }
          }
        }
        .modal-footer {
          padding: 13px 20px;
          text-align: center;
          border-top: 1px solid #e5e5e5;
          background-color: #fff;
          .pull-right {
            float: unset;
            display: flex;
            justify-content: flex-end;
          }
          #wbbm-submit {
            background-color: #d9b581;
            border-color: transparent
          }
        }
      }
      .wbbm-bottom {
        height: 56px;
      }
      .div-modal-text {
        outline: none;
      }
    }
  </style>
